import React from 'react';

import EntityStore from 'stores/EntityStore';

export default function EmptyPage(props) {
  const isSignedOut = !EntityStore.currentUser();
  return (
    <div className="emptyPage-body">
      <img className="emptyPage-icon" src="/static/img/complete.png" />
      <div className="emptyPage-text">
        {(() => {
          if (isSignedOut) {
            return (
              <div>
                <p>
                  <strong>Welcome to Benchling!</strong>
                </p>
                <p>
                  <a href="/signin">Sign in</a> to view data.
                </p>
              </div>
            );
          } else {
            return (
              <div>
                <p>
                  <strong>Your workspace is empty!</strong>
                </p>
                <p>Use the navigation bar on the left to open or create data.</p>
              </div>
            );
          }
        })()}
      </div>
    </div>
  );
}
